package features.shifts.data

import kotlin.js.Promise
import core.firebase.FirestoreClient
import features.shifts.domain.ShiftTemplate

/**
 * Repository for shift template database operations
 */
object ShiftRepository {
    private val db get() = FirestoreClient.db
    
    fun createShift(teamId: String, shift: ShiftTemplate): Promise<Unit> {
        // Manually create plain JavaScript object
        val shiftData = js("{}")
        shiftData["code"] = shift.code
        shiftData["color"] = shift.color
        shiftData["startTime"] = shift.startTime
        shiftData["endTime"] = shift.endTime
        
        console.log("Creating shift with data:", shiftData)
        
        return db.collection("teams").doc(teamId)
            .collection("shifts").doc(shift.id).set(shiftData)
    }
    
    fun loadShifts(teamId: String): Promise<Array<ShiftTemplate>> {
        return db.collection("teams").doc(teamId)
            .collection("shifts").get()
            .then { snapshot ->
                val shifts = mutableListOf<ShiftTemplate>()
                snapshot.forEach { doc ->
                    val data = doc.data()
                    if (data != null) {
                        val shift = ShiftTemplate(
                            id = doc.id,
                            code = data.asDynamic().code as String,
                            color = data.asDynamic().color as String,
                            startTime = data.asDynamic().startTime as String,
                            endTime = data.asDynamic().endTime as String
                        )
                        shifts.add(shift)
                    }
                }
                shifts.toTypedArray()
            }
    }
    
    fun updateShift(teamId: String, shiftId: String, shift: ShiftTemplate): Promise<Unit> {
        console.log("📝 Updating shift: $shiftId in team: $teamId")
        val shiftData = js("{}")
        shiftData["code"] = shift.code
        shiftData["color"] = shift.color
        shiftData["startTime"] = shift.startTime
        shiftData["endTime"] = shift.endTime
        
        return db.collection("teams").doc(teamId)
            .collection("shifts").doc(shiftId).update(shiftData)
            .then {
                console.log("✅ Shift updated successfully")
            }
    }
    
    fun deleteShift(teamId: String, shiftId: String): Promise<Unit> {
        console.log("🗑️ Deleting shift: $shiftId from team: $teamId")
        return db.collection("teams").doc(teamId)
            .collection("shifts").doc(shiftId).delete()
            .then {
                console.log("✅ Shift deleted successfully")
            }
    }
}
